import {
  PAYMENT_METHOD_FIELDS,
  paymentMethods
} from 'lib/constants/healthcareProgram/paymentSetup';

import SwitchController from 'components/practice/Settings/components/HealthcareProgram/components/PaymentProgramTab/components/PaymentSettings/components/SwitchController/SwitchController';
import Typography from 'components/shared/Typography/Typography';

import RecurringChargeConfig from './RecurringChargeConfig';

const PaymentChannelList = ({ channel, channelKey, methods = [], onToggle, onUpdateConfig }) => {
  const findMethod = (field) => methods.find((m) => m.field === field);

  return (
    <>
      <Typography>Payment methods available at the front desk, kiosk, or office.</Typography>
      <div className="flex flex-col gap-2">
        {paymentMethods
          .filter((method) => method.allowed.includes(channel))
          .map((method) => {
            const current = findMethod(method.field);
            const checked = current?.[channelKey] ?? false;
            const isRecurring = method.field === PAYMENT_METHOD_FIELDS.RECURRING_CHARGE;

            return (
              <SwitchController
                key={method.id}
                icon={method.icon}
                title={method.title}
                description={method.description}
                recommended={method.recommended}
                checked={checked}
                onChange={(next) => onToggle(method.field, next)}>
                {isRecurring && (
                  <RecurringChargeConfig
                    config={current?.config}
                    onChange={(nextConfig) => onUpdateConfig(method.field, nextConfig)}
                  />
                )}
              </SwitchController>
            );
          })}
      </div>
    </>
  );
};

export default PaymentChannelList;
